












import Vue from 'vue';

export default Vue.extend({
  name: 'JerseyDropdown',
  props: { options: Array, modelName: String },
  computed: {
    selectModel: {
      get() {
        return (this as any).$store.state[(this as any).modelName].selected;
      },
      set(val: string) {
        (this as any).$store.commit(`set_${(this as any).modelName}`, val);
        return val;
      },
    },
    textModel() {
      return (this as any).$store.state[(this as any).modelName].selected;
    },
  },
});
